import React, { useState } from "react";
import Faqs from "../component/Faqs";

function FaqsContainer({ faqList }) {
  const [activeIndex, setActiveIndex] = useState(null);
  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  return (
    <Faqs
      toggleAccordion={toggleAccordion}
      activeIndex={activeIndex}
      faqList={faqList}
    />
  );
}

export default FaqsContainer;
